import { ReactNode } from 'react';
import { isGA } from '../../constants/environment';

const FormField: React.FC<FormFieldProps> = ({
    children,
    name,
    label,
    required,
    error,
    className,
    forceAsterisk,
}) => (
    <div className={`field${className ? ' ' + className : ''}`}>
        {!!label && (
            <label htmlFor={name} className={`title ${isGA ? 'ga' : 'ix'}`}>
                {label}
                {required || forceAsterisk ? <span className="form-asterisk">*</span> : ''}
            </label>
        )}

        {children}

        {!!error && <p className="form-error">{error}</p>}
    </div>
);

interface FormFieldProps {
    children: ReactNode;
    name: string;
    label?: string;
    required?: boolean;
    error?: string | null;
    className?: string;
    forceAsterisk?: boolean;
}

export default FormField;
